var _circle, _path, _circle2, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReliability(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.9844,
    cy: 36.6797,
    r: 36,
    fill: "#8043F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3984 30.8588V23.1306C18.3984 22.0037 19.33 21.0891 20.4528 20.9928C22.0643 20.8546 24.2336 20.5208 26.3789 19.8151C29.1866 18.8915 33.2841 16.2904 35.785 14.5491C36.5046 14.048 37.4645 14.048 38.1841 14.5491C40.6851 16.2904 44.7826 18.8915 47.5902 19.8151C49.7355 20.5208 51.9048 20.8546 53.5163 20.9928C54.6391 21.0891 55.5707 22.0037 55.5707 23.1306V30.8588C55.5707 36.3778 53.2976 44.4821 48.7929 49.9927C44.8528 54.8126 40.3467 57.7806 37.9012 59.1683C37.3321 59.4912 36.637 59.4912 36.068 59.1683C33.6224 57.7806 29.1163 54.8126 25.1762 49.9927C20.6715 44.4821 18.3984 36.5051 18.3984 30.8588Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5147,
    cy: 35.2767,
    r: 12.6319,
    fill: "#8043F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1016 35.3779L36.7125 39.5907L41.9293 30.9651",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReliability);
export default __webpack_public_path__ + "static/media/reliability.a69f2687ae49a7577a8154fa7662ddfa.svg";
export { ForwardRef as ReactComponent };